import type { TFunction } from "i18next"
import { z } from "zod"

/** Modo do filtro de status: os selecionados entram ou ficam de fora. */
export const STATUS_FILTER_MODES = [
  "include",
  "exclude",
] as const

/** Campos de data que o intervalo pode recortar. */
export const DATE_FIELDS = [
  "created",
  "paid",
  "expires",
  "canceled",
] as const

export const filterOrdersSchema = (t: TFunction) =>
  z.object({
    customerDocument: z.string().optional(),
    code: z.string().optional(),
    ownId: z.string().optional(),
    statuses: z.array(z.string()),
    statusMode: z.enum(STATUS_FILTER_MODES),
    paymentMethods: z.array(z.string()),
    salesChannel: z.string().optional(),
    from: z.date({
      required_error: t("validation.startDateRequired"),
    }),
    to: z.date({
      required_error: t("validation.endDateRequired"),
    }),
    /**
     * A QUAL data o intervalo se aplica.
     *
     * <p>Dois seletores de período lado a lado obrigavam a preencher duas janelas — e o segundo
     * aparecia preenchido sem ninguém ter escolhido, parecendo filtro ativo. Um intervalo só, com
     * a escolha do campo ao lado, faz a mesma pergunta sem esse custo.</p>
     */
    dateField: z.enum(DATE_FIELDS),
    /**
     * Aplica o período MESMO quando a busca é por identificador exato.
     *
     * <p>Buscar por CPF ou código normalmente descarta o período: quem tem o identificador quer
     * AQUELE registro e não sabe de que data ele é. Mas quem procura "os pedidos deste CPF no
     * mês passado" precisa dos dois — e sem esta opção teria de escolher um.</p>
     */
    includePeriodWithIdentifier: z.boolean(),
  })
export type FilterOrdersSchemaProps = z.infer<
  ReturnType<typeof filterOrdersSchema>
>
export type StatusFilterMode =
  FilterOrdersSchemaProps["statusMode"]
export type DateFieldFilter =
  FilterOrdersSchemaProps["dateField"]
